export class ItemComboBox 
{
    Index: String
    Descripcion: String
    Seleccionado: Boolean
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/itemClasses/itemComboBox.class.ts